// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#homepage {
    min-height: 100%;
    text-align: center;
}
#homepage > div {
    margin: 5rem auto;
}
#homepage > div > img {
    height: 192px;
    width: 192px;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,YAAY;AAChB","sourcesContent":["#homepage {\n    min-height: 100%;\n    text-align: center;\n}\n#homepage > div {\n    margin: 5rem auto;\n}\n#homepage > div > img {\n    height: 192px;\n    width: 192px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
